import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import Alert from './../components/Errors/Alert'
import ReCAPTCHA from "react-google-recaptcha";
import _ from 'lodash'

import logo from './../img/indexAR-logo-white.png';
import sponsor1 from './../img/sponsor1.png';
import sponsor2 from './../img/sponsor2.png';
import sponsor3 from './../img/sponsor3.png';

import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners'

class RegisterPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            username: props.username || "",
            email: props.email || "",
            password: props.password || "",
            passwordRepeat: props.passwordRepeat || "",
            humanVerificationCode: null,

            error: null,
        };
        this.recaptchaRef = React.createRef();

        autobind(this)
    }

    componentDidMount() {
        this.props.resetRegistrationStep(1)
        document.title = "Register"
        if (!this.props.domainSubscriptions || !this.props.domainSubscriptions.length)
            this.props.getRegisterSubscriptions()
    }

    componentWillReceiveProps(props) {
        const { error, email, password, passwordRepeat, username, step1 } = props
            , newState = { email, password, passwordRepeat, username, ...this.state, error }

        if (step1)
            return this.props.history.push("/register/contact-info")

        this.setState(newState)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.error !== prevProps.error) {
            this.recaptchaRef.current.reset()
        }
    }

    onUsernameChange(event) {
        this.setState({ username: event.target.value });
    }

    onEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    onPasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    onPasswordRepeatChange(event) {
        this.setState({ passwordRepeat: event.target.value });
    }

    onHumanVerificationCodeChange(value) {
        this.setState({ humanVerificationCode: value });
    }

    onRegisterButtonClick(e) {
        e.preventDefault();

        const { username, email, password, passwordRepeat, humanVerificationCode } = this.state
        const moduleOptions = [{domainId: "5a81e8ac252c65378b88df6b", active: true, domainName: "Furniture"}];
        this.props.registerFlowStep1(username, email, password, passwordRepeat, humanVerificationCode, moduleOptions)
    }

    render() {

        const { username, email, password, passwordRepeat, error } = this.state
            , { registering } = this.props


        return (
            <div className="white-bg-top-wrapper">
                <div className="splash-wrapper">
                    <div className="d-flex justify-content-between flex-wrap mb-5">
                        <img src={sponsor1} width="135" height="107" alt="Sponsor" />
                        <img src={sponsor2} width="114" height="114" alt="Sponsor" />
                        <img src={sponsor3} width="127" height="120" alt="Sponsor" />
                    </div>
                    <div className="splash-container row">
                        <div className="col-sm-6 form-message d-flex justify-content-center justify-content-between">

                            <form className="sign-up-form">
                                {error ? <Alert message={error} /> : null}
                                {registering ? (
                                    <div className="w-100 text-center">
                                        <ClipLoader
                                            color={'#2CC185'}
                                            loading={true}
                                            className="d-inline-block"
                                        />
                                    </div>
                                ) : null}
                                <div className="form-group">
                                    <div className="input-group"><span className="input-group-addon"><i className="icon s7-user"></i></span>
                                        <input type="text" placeholder="Author Name" className="form-control" onChange={this.onUsernameChange} value={username} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group"><span className="input-group-addon"><i className="icon s7-mail"></i></span>
                                        <input type="email" placeholder="E-mail" className="form-control" onChange={this.onEmailChange} value={email} />
                                    </div>
                                </div>
                                <div className="form-group inline row mb-px-30">
                                    <div className="col-6">
                                        <div className="input-group"><span className="input-group-addon"><i className="icon s7-unlock"></i></span>
                                            <input type="password" placeholder="Password" className="form-control" onChange={this.onPasswordChange} value={password} />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="input-group"><span className="input-group-addon"><i className="icon s7-unlock"></i></span>
                                            <input type="password" placeholder="Confirm" className="form-control" onChange={this.onPasswordRepeatChange} value={passwordRepeat} />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <ReCAPTCHA ref={this.recaptchaRef} theme="dark" sitekey="6LfSuIsUAAAAAFg3DPTTEteo4Bzs7GtpPXZeJ7yB" onChange={this.onHumanVerificationCodeChange}/>
                                </div>
                                <div className="form-group sign-up-submit">
                                    <button type="submit" className="btn btn-lg btn-primary btn-block" onClick={this.onRegisterButtonClick}>Sign up</button>
                                </div>
                            </form>
                            <div>
                                <p className="conditions text-center" style={{ color: 'white' }}>By creating an account, you agree with the <br /> <a href='https://indexar.tech/terms-and-conditions/#companies' rel="noopener noreferrer" target="_blank">Terms and Conditions</a> and <a href='https://indexar.tech/terms-and-conditions/#privacy-policy' rel="noopener noreferrer" target="_blank">Privacy Policy</a>.</p>
                                <p className="conditions text-center mt-4">© {(new Date().getFullYear())} indexAR</p>
                            </div>
                        </div>
                        <img src={logo} alt="logo" width="117" height="102" className="logo-img mb-4 register-logo" />
                        <div className="col-sm-6 user-message d-flex justify-content-between">
                            <span className="splash-message text-left mb-px-22">Welcome to<br /> indexAR<br /> Enjoy!</span>
                            <span className="alternative-message mb-px-10">Do you have an account? <Link to="/login">Sign In</Link></span>
                        </div>
                    </div>
                    <div className="text-center mt-px-100">
                        <p className="mb-2 disclaimer-text">Pentru informaţii detaliate despre celelalte programe cofinanţate de Uniunea Europeană, vă invităm să vizitaţi <a href="http://www.fonduri-ue.ro">www.fonduri-ue.ro</a></p>
                        <p className="text-xs">Conţinutul acestui material nu reprezintă în mod obligatoriu poziţia oficială a Uniunii Europene sau a Guvernului României</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { registerFlow: { username, email, password, passwordRepeat, error, step1, registering }, registerPaymentPlans: { domainSubscriptions } } = state
        return { username, email, password, passwordRepeat, domainSubscriptions, error, step1, registering }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps);
    }
)(withRouter(RegisterPage))



// WEBPACK FOOTER //
// ./src/containers/Register.js